import { SearchInput, ClearFiltersButton } from "../common/ClearControls";
import React, { useState, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import styles from "./ImageGallery.module.scss";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import PhotoCameraBackIcon from "@mui/icons-material/PhotoCameraBack";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { Chip } from "@mui/material";
import Lottie from "lottie-react";
import videoLoadingAnimation from "../animation/Animation - 1741783692232.json";
import { set } from "lodash";
import { Autocomplete, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GoogleImageSearch from './GoogleImageSearch';
import useGoogleImageUpload from './useGoogleImageUpload';
import GoogleImageUploadStatus from './GoogleImageUploadStatus';
import CropperComponent from "./CropperComponent";
import CameraCaptureUploader from "../MobileUplaod/imageUplaod";
import CropIcon from '@mui/icons-material/Crop';



const ImageGalleryV2 = ({ showGallery, onClose }) => {
  const [activeTab, setActiveTab] = useState("stock_images");
  const [galleryData, setGalleryData] = useState({
    stock_gifs: [],
    stock_images: [],
    private: [],
  });
  const [uploadedImages, setUploadedImages] = useState([]);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [isConfidential, setIsConfidential] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [searchQueryGoogle, setSearchQueryGooogle] = useState("");


  const [categories, setCategories] = useState([]);
  const [imageName, setImageName] = useState("");
  const [matchingCategories, setMatchingCategories] = useState([])
  const [filteredImages, setFilteredImages] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryImagesMap, setCategoryImagesMap] = useState({});


const [cropModalOpen, setCropModalOpen] = useState(false);
const [imageToCropURL, setImageToCropURL] = useState<string | null>(null);
const [imageToCropIndex, setImageToCropIndex] = useState<number | null>(null);

  const fetchGalleryData = async (searchQuery = "") => {
    try {
      const token = axios.defaults.headers.common.Authorization;
      if (!token) {
        console.error("Authorization token is missing.");
        return;
      }
      setLoadingSearch(true);
      const response = await axios.get(
        `consent_clause/get_user_media?search=${searchQuery}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      setGalleryData(response.data);
      setImageName("");
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    } finally {
      setLoadingSearch(false);
    }
  };

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      fetchGalleryData(searchQuery);
    }, 500); 

    return () => clearTimeout(debounceTimeout);
  }, [searchQuery]);

  const formatDuration = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
  
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const fetchCategories = async () => {
    try {
     
      const { data } = await axios.post(`/treatment_category`);
      setCategories(data);
     
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (categories.length === 0 || !galleryData) return;
  
    const newCategoryImagesMap = {};
  
    const categorizeItems = (items, type) => {
  items.forEach((item) => {
    const idsArray = Array.isArray(item.category_ids) ? item.category_ids : [item.category_id];

    idsArray.forEach((catId) => {
      const categoryName = categories.find((category) => category.id === catId)?.category_name;

      if (categoryName) {
        if (!newCategoryImagesMap[categoryName]) {
          newCategoryImagesMap[categoryName] = {
            stock_gifs: [],
            stock_images: [],
            private: [],
          };
        }

        if (type === "private") {
          newCategoryImagesMap[categoryName][type].push(item);
        } else if (!galleryData.private.some(p => p.id === item.id)) {
          newCategoryImagesMap[categoryName][type].push(item);
        }
      }
    });
  });
};


    categorizeItems(galleryData.stock_gifs, "stock_gifs");
    categorizeItems(galleryData.stock_images, "stock_images");
    categorizeItems(galleryData.private, "private");

   Object.keys(newCategoryImagesMap).forEach((categoryName) => {
  const categoryData = newCategoryImagesMap[categoryName];
  const isEmpty =
    (!categoryData.stock_gifs || categoryData.stock_gifs.length === 0) &&
    (!categoryData.stock_images || categoryData.stock_images.length === 0) &&
    (!categoryData.private || categoryData.private.length === 0);

  if (isEmpty) {
    delete newCategoryImagesMap[categoryName];
  }
});
  
    setCategoryImagesMap(newCategoryImagesMap);
    setFilteredImages([]);
  }, [categories, galleryData]);
   
  const handleCategoryClick = (categoryName) => {
    if (categoryName === "All") {
      setSelectedCategory(null);
      setFilteredImages([]); 
    } else if (selectedCategory === categoryName) {
      setSelectedCategory(null);
      setFilteredImages([]); 
    } else {
      setSelectedCategory(categoryName);

      const imagesForCategory = [
        ...(activeTab === "stock_gifs" ? categoryImagesMap[categoryName]?.stock_gifs || [] : []),
        ...(activeTab === "stock_images" ? categoryImagesMap[categoryName]?.stock_images || [] : []),
        ...(activeTab === "private" ? categoryImagesMap[categoryName]?.private || [] : []),
      ];
  
      setFilteredImages(imagesForCategory);
    }
  };

  const renderImages = () => {
    const imagesToRender = selectedCategory ? filteredImages : galleryData[activeTab];
  
    return imagesToRender.map((item) => {
      const keywords = typeof item.keywords === "string"
        ? item.keywords.split(",").map((keyword) => keyword.trim())
        : [];
  
      return (
        <div key={item.id} className={styles.imageItemContainer}>
          <div className={styles.imageItem}>
            <div className={styles.imageWrapper}>
              <Tooltip title={keywords.join(", ")}>
                <div className={styles.imageContainer}>
                  <img
                    src={item.url}
                    alt={item.name}
                    className={styles.galleryImage}
                  />
                </div>
              </Tooltip>
  
              {/* Duration Overlay */}
              {item.duration && (
                <div className={styles.durationOverlay}>
                  {formatDuration(item.duration)}
                </div>
              )}
  
              {/* Confidential Icon */}
              {item.is_confidential && (
                <Tooltip title="Confidential">
                  <GppMaybeIcon className={styles.confidentialIcon} />
                </Tooltip>
              )}
            </div>
          </div>
  
          {/* Delete Button for Psrivate Tab */}
          {activeTab === "private" && (
            <IconButton
              className={styles.deleteButton}
              onClick={() => handleDeleteImage(item.id)}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </div>
      );
    });
  };
  
  const handleDeleteImage = async (mediaId) => {
    try {
      const token = axios.defaults.headers.common.Authorization;
      if (!token) {
        toast.error("Authorization token is missing.");
        return;
      }
      await axios.put(
        `/consent_clause/archive_user_media/${mediaId}`,
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      );
      toast.success("Media archived successfully.");
      fetchGalleryData();
    } catch (error) {
      console.error("Error archiving media:", error);
      toast.error("Failed to archive media.");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/gif': [],
      'image/jpg': [],
    },
    multiple: false,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        setUploadedImages([acceptedFiles[0]]); 
      }
    },
  });
  

  const removeImage = (index) => {
    const newImages = uploadedImages.filter((_, i) => i !== index);
    setUploadedImages(newImages);
  };

  const handleImageUpload = async () => {
    const token = axios.defaults.headers.common.Authorization;
    setLoading(true);

    if (uploadedImages.length > 0) {
      try {
        for (const file of uploadedImages) {
          const fileSizeInMB = file.size / (1024 * 1024);
          if (fileSizeInMB > 2) {
            toast.error("Image is too large, more than 2MB.");
            return; 
          }

          const formData = new FormData();
          formData.append("file", file);
        
        formData.append("user_file_name", imageName);
          formData.append("keywords", keywords);  
          formData.append("category_id", selectedCategory);  

          await axios.post("consent_clause/upload_user_media_to_s3", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: token,
            },
          });
        }

        toast.success("Content added to the Image gallery");
        fetchGalleryData();
        closeImageModal();
      } catch (error) {
        console.error("Error uploading image:", error);
        // toast.error("Error uploading images");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("No images to upload.");
      setLoading(false);
    }
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
    setUploadedImages([]);
    setIsConfidential(false);
  };


  useEffect(() => {
    if (showGallery) fetchGalleryData();
  }, [showGallery]);

  if (!showGallery) return null;

    const handleRefresh = () => {
      console.log("Refreshing gallery data...");
      fetchGalleryData(); 
    };

  return (
    <div>
     <div className={styles.header}>
      <IconButton
            onClick={handleRefresh} 
            className={styles.refreshButton}
            style={{ marginLeft: "10px" }}
            size="large"
          >
            <RefreshIcon />
          </IconButton>
        <h3 className={styles.topic}>Image Gallery</h3>
        <div className={styles.actions}>
          <ClearFiltersButton onClear={() => {
            setSearchQuery(""); setSearchQueryGooogle(""); setSelectedCategory(null); setFilteredImages([]); fetchGalleryData();
          }} />
          <Button
            variant="contained"
            onClick={() => setIsImageModalOpen(true)}
            className={styles.uploadButton}
          >
            +
            <PhotoCameraBackIcon
              style={{ marginLeft: "10px", fontSize: "20px" }}
            />
          </Button>

          <IconButton
            onClick={onClose}
            className={styles.closeButton}
            style={{ marginLeft: "10px" }}
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </div>
      </div>


      <div>
      {/* Search Bar here */}
      <div style={{ display: 'flex', marginBottom: '20px' }}>
        <div style={{ position: 'relative', flex: 1 }}>
          <SearchInput onClear={() => { setSearchQueryGooogle(""); }}
            type="text"
            placeholder="Search Google Images..."
            value={searchQueryGoogle}
            onChange={(e) => setSearchQueryGooogle(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && {} }
            style={{
              width: '87%',
              padding: '14px 40px 14px 14px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              fontSize: '18px',
              backgroundColor: '#f9f9f9',
            }}
          />
         
        </div>

      
        <GoogleImageSearch
          searchQuery={searchQueryGoogle}
          setSearchQuery={setSearchQueryGooogle}
          onUploadSuccess={handleRefresh}
        />
      </div>
    </div>


    {/* tbs Section */}
    <div className={styles.tabContainer}>
      {["stock_images", "stock_gifs", "private"].map((tab) => (
        <button
          key={tab}
          type="button"
          className={`${styles.tabButton} ${
            activeTab === tab ? styles.activeTab : ""
          }`}
          onClick={() => {
            setActiveTab(tab);
            if (selectedCategory !== "All") {
              handleCategoryClick("All");
            }
          }}
        >
          {tab.replace("_", " ").toUpperCase()}
        </button>
      ))}
    </div>

    {/* catogaty chip Section */}
    <div className={styles.categoryChipsContainer}>
      {Object.keys(categoryImagesMap).some((categoryName) => {
        const hasStockImages =
          (categoryImagesMap[categoryName]?.stock_images || []).length > 0;
        const hasPrivateImages =
          (categoryImagesMap[categoryName]?.private || []).length > 0;
        const hasStockGifs =
          (categoryImagesMap[categoryName]?.stock_gifs || []).length > 0;

        return (
          (activeTab === "stock_images" && hasStockImages) ||
          (activeTab === "stock_gifs" && hasStockGifs) ||
          (activeTab === "private" && hasPrivateImages)
        );
      }) && (
        <button
      type="button"
      className={`${styles.categoryChip} ${
        selectedCategory === "All" ? styles.selectedCategory : ""
      }`}
      onClick={() => handleCategoryClick("All")}
    >
      <RefreshIcon className={styles.refreshIcon} /> {/* Add the icon */}
      All
    </button>
      )}

      {/* Category Chips */}
      {Object.keys(categoryImagesMap).map((categoryName) => {
        const hasStockImages =
          (categoryImagesMap[categoryName]?.stock_images || []).length > 0;
        const hasPrivateImages =
          (categoryImagesMap[categoryName]?.private || []).length > 0;
        const hasStockGifs =
          (categoryImagesMap[categoryName]?.stock_gifs || []).length > 0;

        const shouldDisplayCategoryChip =
          (activeTab === "stock_images" && hasStockImages) ||
          (activeTab === "stock_gifs" && hasStockGifs) ||
          (activeTab === "private" && hasPrivateImages);

        if (!shouldDisplayCategoryChip) return null;

        return (
          <button
            key={categoryName}
            type="button"
            className={`${styles.categoryChip} ${
              selectedCategory === categoryName ? styles.selectedCategory : ""
            }`}
            onClick={() => handleCategoryClick(categoryName)}
          >
            {categoryName}
          </button>
        );
      })}
    </div>

    {/* Search Bar */}
    <div>
      {(activeTab === "stock_images" || activeTab === "stock_gifs") && (
        <div className={styles.searchBarContainer}>
          <SearchInput onClear={() => { setSearchQuery(""); }}
            type="text"
            placeholder="Search..."
            className={styles.searchInput}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      )}

      {loadingSearch && <p>Loading...</p>}

      <div className={styles.imageGallery}>{renderImages()}</div>
    </div>

      
      <ImageUploadModal
        open={isImageModalOpen}
        onClose={closeImageModal}
        onUpload={handleImageUpload}
        uploadedImages={uploadedImages}
        setUploadedImages={setUploadedImages}
        onRemoveImage={removeImage}
        getInputProps={getInputProps}
        isConfidential={isConfidential}
        imageName={imageName}
        setImageName={setImageName} 
        getRootProps={getRootProps}
        setIsConfidential={setIsConfidential}
        fetchGalleryData={fetchGalleryData}
        closeImageModal={closeImageModal}
      />
      <LoadingModal open={loading} />
    </div>
  );
};


const ImageGalleryTooltip = () => (
  <div>
    <Typography variant="h6" style={{ marginBottom: "10px" }}>
      Image Gallery :
    </Typography>
    <List style={{ fontSize: "16px" }}>
      <ListItem>
        <ListItemText primary="Upload directly from the upload image button." />
      </ListItem>
      <ListItem>
        <ListItemText primary="Add image to editor and save; it will automatically be added to the gallery." />
      </ListItem>
      <ListItem>
        <ListItemText primary="Use your mobile to capture and upload images (Coming soon!)." />
      </ListItem>
    </List>
  </div>
);




// image uplaod modal*******************************


const ImageUploadModal = ({
    open,
    onClose,
    uploadedImages,
    setUploadedImages,
    onRemoveImage,
    getInputProps,
    getRootProps,
    isConfidential,
    setIsConfidential,
    imageName,
    setImageName,
    fetchGalleryData,
    closeImageModal
}) => {
  const googleUploader = useGoogleImageUpload();
  
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [keywords, setKeywords] = useState("");
  const [loading, setLoading] = useState(false);
  const [keywordsArray, setKeywordsArray] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [imageResults, setImageResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [uploadMode, setUploadMode] = useState<'upload' | 'search'>('upload');
  const apiKey = 'AIzaSyDBGKDuYYvI1DRbCjvrtnCRasnGukhYOes';
  const cx = '30dca0bba2d8b4b27';
  const numResults = 10;
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [imageToCrop, setImageToCrop] = useState<string | null>(null);


const [imageToCropIndex, setImageToCropIndex] = useState<number | null>(null);
const [imageToCropURL, setImageToCropURL] = useState<string | null>(null);


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axios.post(`/treatment_category`);
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    if (open) {
      fetchCategories();
    }
  }, [open]);

  const resizeImage = (file: File, maxWidth: number, maxHeight: number): Promise<File> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = () => {
        img.onload = () => {
          // Original size
          const originalWidth = img.width;
          const originalHeight = img.height;
  
          // Calculate aspect-ratio-preserving new size
          let targetWidth = originalWidth;
          let targetHeight = originalHeight;
  
          if (originalWidth > maxWidth || originalHeight > maxHeight) {
            const widthRatio = maxWidth / originalWidth;
            const heightRatio = maxHeight / originalHeight;
            const scale = Math.min(widthRatio, heightRatio);
            targetWidth = originalWidth * scale;
            targetHeight = originalHeight * scale;
          }
  
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            reject("Canvas context not found");
            return;
          }
  
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
  
          const originalSizeMB = (file.size / (1024 * 1024)).toFixed(2);
          console.log(`Original size: ${originalSizeMB} MB`);
  
          const compress = (quality: number) => {
            canvas.toBlob((blob) => {
              if (!blob) {
                reject("Failed to compress");
                return;
              }
  
              const sizeMB = blob.size / (1024 * 1024);
              console.log(`Compressed size: ${sizeMB.toFixed(2)} MB (quality: ${quality})`);
  
              if (sizeMB <= 1.5 || quality <= 0.2) {
                const resizedFile = new File([blob], file.name, { type: file.type });
                resolve(resizedFile);
              } else {
                compress(quality - 0.05);
              }
            }, file.type, quality);
          };
  
          canvas.toBlob((initialBlob) => {
            if (!initialBlob) {
              reject("Failed to create blob");
              return;
            }
  
            const resizedSizeMB = initialBlob.size / (1024 * 1024);
            console.log(`Resized size: ${resizedSizeMB.toFixed(2)} MB`);
  
            if (resizedSizeMB > 1.5) {
              compress(0.9);
            } else {
              const resizedFile = new File([initialBlob], file.name, { type: file.type });
              resolve(resizedFile);
            }
          }, file.type, 1);
        };
  
        img.src = reader.result as string;
      };
  
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };
  
  const [categoryError, setCategoryError] = useState(false);
  const handleImageUpload = async () => {

    if (selectedCategories.length === 0) {
    setCategoryError(true);
    return;
  }
    setCategoryError(false);

    const token = axios.defaults.headers.common.Authorization;
    setLoading(true);
    const categoryIds = selectedCategories.map(cat => cat.id);
    console.log(uploadedImages, "uploadedImages")

    if (uploadedImages.length > 0) {
      try {
        for (const file of uploadedImages) {
          const fileSizeInMB = file.size / (1024 * 1024);
          console.log(keywordsArray, "keywords")
          const resizedFile = await resizeImage(file, 300, 202);
          const formData = new FormData();
          console.log("Uploading file:", file.name, `${(file.size / (1024 * 1024)).toFixed(2)} MB`);
          console.log("Resized file:", resizedFile.name, `${(resizedFile.size / (1024 * 1024)).toFixed(2)} MB`);
          console.log("Resized file type:", resizedFile.type);
          
          formData.append("file", resizedFile);
          formData.append("is_confidential", isConfidential ? "true" : "false");
          formData.append("user_file_name", imageName);
          formData.append("keywords", keywordsArray); 
          // formData.append("category_id", selectedCategory ? selectedCategory : "null");
          categoryIds.forEach((id) => {
            formData.append("category_ids", id.toString());
          });
          

          console.log("Form data:", formData.get("file"), formData.get("is_confidential"), formData.get("user_file_name"), formData.get("keywords"), formData.get("category_id"));

          await axios.post("consent_clause/upload_user_media_to_s3", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: token,
            },
          });
        }

        toast.success("Content added to the Image gallery");

        setCategories([]);            
        setSelectedCategory("");
        setSelectedCategories([]);      
        setKeywords("");  
        setKeywordsArray([]); 

        fetchGalleryData();
        closeImageModal();
      } catch (error) {
        console.error("Error uploading image:", error);
       
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("No images to upload.");
      setLoading(false);
    }
  };

  const handleImageSearchUpload = async () => {
    console.log("Selected Google Image:", selectedGoogleImage);
     if (selectedCategories.length === 0) {
    setCategoryError(true);
    return;
  }
    setCategoryError(false);
  
    setLoading(true);
    const categoryIds = selectedCategories.map(cat => cat.id);
    if (!selectedGoogleImage) {
      toast.error("No image URL selected.");
      setLoading(false);
      return;
    }
  
    try {
      const formData = new FormData();
    
      formData.append("image_url", selectedGoogleImage);
      formData.append("is_confidential", isConfidential ? "true" : "false");
      formData.append("user_file_name", imageName);
      formData.append("keywords", keywordsArray);
      categoryIds.forEach((id) => {
            formData.append("category_ids", id.toString());
          });
  
      console.log("Uploading image URL:", selectedGoogleImage);
      console.log("Form data:", formData.get("image_url"), formData.get("is_confidential"), formData.get("user_file_name"), formData.get("keywords"), formData.get("category_id"));
  
      const response = await googleUploader.upload(formData);
      if (!response) return;
  
      toast.success("Content added to the Image gallery");
  
      setCategories([]);
      setSelectedCategory("");
      setKeywords("");
      setKeywordsArray([]);
      fetchGalleryData();
      closeImageModal();
    } catch (error) {
      console.error("Error uploading image URL:", error);
      toast.error(error instanceof Error ? error.message : "Failed to upload image.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeywordChange = (e) => {
    setKeywords(e.target.value);
  };

  const handleKeywordAdd = (e) => {
    if (e.key === 'Enter' && keywords.trim()) {
      const newKeyword = keywords.trim();
      if (!keywordsArray.includes(newKeyword)) {
        setKeywordsArray([...keywordsArray, newKeyword]);
      }
       setKeywords(''); 
    }
  };

  const handleRemoveKeyword = (keyword) => {
    setKeywordsArray(keywordsArray.filter((kw) => kw !== keyword));
  };

  const googleSearchVersionRef = useRef(0);
  const handleSearch = async () => {
  const searchVersion = ++googleSearchVersionRef.current;
  setLoading(true);
  try {
    const startIndex = (currentPage - 1) * numResults + 1;
    const rightsFilter = 'cc_publicdomain|cc_attribute|cc_commercial|cc_nonderived';
    const apiUrl = `https://www.googleapis.com/customsearch/v1?q=${encodeURIComponent(searchQuery)}&cx=${cx}&searchType=image&key=${apiKey}&num=${numResults}&start=${startIndex}&rights=${rightsFilter}`;
    
    const response = await fetch(apiUrl);
    const data = await response.json();
    if (searchVersion !== googleSearchVersionRef.current) return;
 
    console.log('Google API items:', data.items);
    
    const results = (data.items || []).filter(item => {
      const link = item.link?.toLowerCase();
      return link && (link.endsWith('.jpg') || link.endsWith('.jpeg') || link.endsWith('.png'));
    });
    setImageResults(results);
  } catch (error) {
    if (searchVersion !== googleSearchVersionRef.current) return;
    console.error('Error fetching search results:', error);
  } finally {
    if (searchVersion !== googleSearchVersionRef.current) return;
    setLoading(false);
  }
};


  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
    handleSearch();
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      handleSearch(); 
    }
  };
  
  const handleClear = () => {
    googleSearchVersionRef.current += 1; setLoading(false);
    setSearchQuery('');
    setImageResults([]);
    setCurrentPage(1);
  };

  const [selectedGoogleImage, setSelectedGoogleImage] = useState<string | null>(null);
  const handleGoogleImageSelect = (url: string) => {
    setSelectedGoogleImage(url);
    console.log("Selected Google Image URL:", url);
  };

const onDrop = (acceptedFiles: File[]) => {
  const file = acceptedFiles[0];
  const reader = new FileReader();

  reader.onload = () => {
    setUploadedImages((prev) => [...prev, file]);
    setImageToCropIndex(prev => prev.length); 
    setImageToCropURL(reader.result as string);
    setCropModalOpen(true);
  };

  reader.readAsDataURL(file);
};

const handleCropComplete = (croppedFile: File) => {
  if (imageToCropIndex !== null) {
    const updated = [...uploadedImages];
    updated[imageToCropIndex] = croppedFile;
    setUploadedImages(updated);
  }

  setCropModalOpen(false);
  setImageToCropIndex(null);
  setImageToCropURL(null);
};



  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "8px",
          boxShadow: 24,
          minWidth: "1000px",
          minHeight: "900px",
          maxWidth: "1000px",
          maxHeight: "900px",
          overflow: "auto",
        }}
      >
        <h2>Upload an Image to Gallery</h2>

        <div style={{ display: 'flex', marginBottom: '20px' }}>
          <div
            onClick={() => setUploadMode('upload')}
            style={{
              padding: '10px 20px',
              cursor: 'pointer',
              borderBottom: uploadMode === 'upload' ? '3px solid orange' : '3px solid transparent',
              fontWeight: uploadMode === 'upload' ? 'bold' : 'normal'
            }}
          >
            Upload Image
          </div>
          
          <div
            onClick={() => setUploadMode('search')}
            style={{
              padding: '10px 20px',
              cursor: 'pointer',
              borderBottom: uploadMode === 'search' ? '3px solid orange' : '3px solid transparent',
              fontWeight: uploadMode === 'search' ? 'bold' : 'normal'
            }}
          >
            Search Image
          </div>

          {/* <div
            onClick={() => setUploadMode('capture')}
            style={{
              padding: '10px 20px',
              cursor: 'pointer',
              borderBottom: uploadMode === 'search' ? '3px solid orange' : '3px solid transparent',
              fontWeight: uploadMode === 'search' ? 'bold' : 'normal'
            }}
          >
            Capture Image
          </div> */}
          
        </div>


        {uploadMode === 'search' && (
          <>
                <div>
              {/* Search Bar */}
              <div style={{ display: 'flex', marginBottom: '20px' }}>
          <SearchInput onClear={() => { handleClear(); }}
            type="text"
            placeholder="Search Google Images..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            style={{
              flex: 1,
              padding: '14px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              fontSize: '18px',
              backgroundColor: '#f9f9f9',
            }}
          />
          <button
            onClick={handleSearch}
            style={{
              padding: '14px 20px',
              borderRadius: '8px',
              marginLeft: '10px',
              backgroundColor: '#0056b3',
              color: 'white',
              border: 'none',
              fontSize: '18px',
              cursor: 'pointer',
            }}
          >
            Search
          </button>
          <button
            onClick={handleClear}
            style={{
              padding: '14px 20px',
              borderRadius: '8px',
              marginLeft: '10px',
              backgroundColor: '#aaa',
              color: 'white',
              border: 'none',
              fontSize: '18px',
              cursor: 'pointer',
            }}
          >
            Clear
          </button>
            </div>

      {/* Image Search Results */}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {imageResults.length > 0 && imageResults.map((result, index) => (
          <div key={index} style={{ margin: '10px', textAlign: 'center' }}>
            <img
              src={result.link}
              alt="Image result"
              onClick={() => handleGoogleImageSelect(result.link)}
              style={{
                width: '200px',
                height: '200px',
                objectFit: 'cover',
                borderRadius: '8px',
                cursor: 'pointer',
                border: selectedGoogleImage === result.link ? '3px solid #0056b3' : 'none',
              }}
            />
          </div>
        ))}
      </div>

      {/* Pagination Controls */}
      {imageResults.length > 0 && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            style={{ padding: '10px 20px', marginRight: '10px' }}
          >
            Previous
          </button>
          <button
            onClick={handleNextPage}
            style={{ padding: '10px 20px' }}
          >
            Next
          </button>
        </div>
      )}

            {loading && <p>Loading...</p>}
          </div>
          </>
        )}

        {uploadMode === 'upload' && (
  <>
    {/* Dropzone */}
    <div {...getRootProps()} style={{
      border: "2px dashed #003366",
      padding: "60px",
      textAlign: "center",
      borderRadius: "8px",
      backgroundColor: "#f8f8f8",
      marginBottom: "20px",
      marginTop: "50px",
    }}>
      <p>Drag and drop image/Gif here (accepted formats: .jpg, .jpeg, .gif, .png)</p>
      <p>or</p>
      <p>Click to upload image/Gif</p>
    </div>

    {/* Cropper Modal */}
    {imageToCropURL && (
      <CropperComponent
        open={cropModalOpen}
        image={imageToCropURL}
        onClose={() => setCropModalOpen(false)}
        onCropComplete={handleCropComplete}
      />
    )}

    {/* Image Preview */}
 
<div
  style={{
    marginTop: "20px",
    textAlign: "center",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px", // better spacing between items
  }}
>
  {uploadedImages.map((file, index) => (
    <div
      key={index}
      style={{
        position: "relative",
        margin: "10px",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        backgroundColor: "#fff",
        maxWidth: "320px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "8px",
      }}
    >
      <img
        src={URL.createObjectURL(file)}
        alt="Preview"
        style={{
          maxWidth: "300px",
          maxHeight: "180px",
          objectFit: "contain",
          borderRadius: "6px",
          userSelect: "none",
        }}
        draggable={false}
      />
      
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          marginTop: "12px",
          width: "100%",
        }}
      >
        <Tooltip title="Crop Image" arrow>
          <IconButton
            color="primary"
            size="small"
            onClick={() => {
              setImageToCropIndex(index);
              setImageToCropURL(URL.createObjectURL(file));
              setCropModalOpen(true);
            }}
            sx={{
              border: "1.5px solid #1976d2",
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            <CropIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Delete Image" arrow>
          <IconButton
            size="small"
            onClick={() => onRemoveImage(index)}
            sx={{
              color: "white",
              backgroundColor: "rgba(220,20,60,0.85)", // crimson red
              "&:hover": {
                backgroundColor: "rgba(220,20,60,1)",
              },
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  ))}
</div>

  </>
        )}


        {/* Confidential Checkbox */}
        {uploadMode !== 'capture' && (
              <>
                {/* Confidential Checkbox */}
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <label style={{ marginBottom: "10px" }}>
                    <input
                      type="checkbox"
                      checked={isConfidential}
                      onChange={(e) => setIsConfidential(e.target.checked)}
                    />
                    Mark this image as confidential
                  </label>
                </div>

                {/* Image Name Input */}
                <input
                  type="text"
                  placeholder="Enter image name..."
                  value={imageName}
                  onChange={(e) => {
                    setImageName(e.target.value);
                  }}
                  style={{
                    width: "97%",
                    padding: "14px",
                    marginBottom: "20px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "18px",
                    backgroundColor: "#f9f9f9",
                    transition: "all 0.3s ease-in-out",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#0056b3")}
                  onBlur={(e) => (e.target.style.borderColor = "#ddd")}
                  required
                />

                {/* Category Dropdown */}
                <Autocomplete
                  multiple
                  id="categories-autocomplete"
                  options={categories}
                  getOptionLabel={(option) => option.category_name}
                  value={selectedCategories}
                  onChange={(event, newValue) => {
                    setSelectedCategories(newValue);
                    setCategoryError(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select categories"
                      placeholder="Start typing to search..."
                      error={categoryError}
                      helperText={
                        categoryError ? "Please select at least one category" : ""
                      }
                      sx={{
                        marginBottom: "20px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "8px",
                      }}
                    />
                  )}
                  sx={{ width: "100%" }}
                />

                {categoryError && (
                  <span
                    style={{
                      color: "red",
                      marginBottom: "15px",
                      display: "block",
                    }}
                  >
                    Please select a category before uploading.
                  </span>
                )}

                {/* Keywords Input */}
                <div style={{ marginBottom: "20px" }}>
                  <input
                    type="text"
                    placeholder="Enter keywords (press Enter to add each keyword)"
                    value={keywords}
                    onChange={handleKeywordChange}
                    onKeyDown={handleKeywordAdd}
                    style={{
                      width: "97%",
                      padding: "14px",
                      marginBottom: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      fontSize: "18px",
                      backgroundColor: "#f9f9f9",
                      transition: "all 0.3s ease-in-out",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#0056b3")}
                    onBlur={(e) => (e.target.style.borderColor = "#ddd")}
                    required
                  />

                  {/* Display entered keywords as chips */}
                  <div style={{ marginTop: "10px" }}>
                    {keywordsArray.map((keyword, index) => (
                      <span
                        key={index}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "10px",
                          backgroundColor: "#e0e0e0",
                          borderRadius: "20px",
                          padding: "5px 10px",
                        }}
                      >
                        {keyword}
                        <Button
                          size="small"
                          onClick={() => handleRemoveKeyword(keyword)}
                          style={{
                            marginLeft: "8px",
                            padding: "2px",
                            minWidth: "auto",
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </Button>
                      </span>
                    ))}
                  </div>
                </div>
              </>
        )}


        {uploadMode === 'upload' && (
  <>

        {/* Buttons */}
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{
              padding: "12px 20px",
              borderRadius: "8px",
              flex: 1,
              marginRight: "10px",
            }}
            onClick={handleImageUpload}
            disabled={(uploadedImages.length === 0 && !selectedGoogleImage) || loading}
          >
            {loading ? "Uploading..." : "Upload Image"}
          </Button>



          <Button
            variant="outlined"
            style={{
              padding: "12px 20px",
              borderRadius: "8px",
              flex: 1,
              marginLeft: "10px",
            }}
            onClick={onClose}
          >
            Close
          </Button>
        </div>
        </>
        )}

        {uploadMode === 'search' && (
    <>

          <GoogleImageUploadStatus state={googleUploader.state} connection={googleUploader.connection} elapsedSeconds={googleUploader.elapsedSeconds} />
          {/* Buttons */}
          <div style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              style={{
                padding: "12px 20px",
                borderRadius: "8px",
                flex: 1,
                marginRight: "10px",
              }}
              onClick={handleImageSearchUpload}
              disabled={(uploadedImages.length === 0 && !selectedGoogleImage) || loading}
            >
              {loading ? "Uploading Selected Image..." : "Upload Selected Image"}
            </Button>



            <Button
              variant="outlined"
              style={{
                padding: "12px 20px",
                borderRadius: "8px",
                flex: 1,
                marginLeft: "10px",
              }}
              onClick={onClose}
            >
              Close
            </Button>
          </div>
          </>
        )}

      {uploadMode === 'capture' && (
        <><CameraCaptureUploader /></>
      )}


      </Box>
    </Modal>
  );
};




const LoadingModal = ({ open }) => (
  <Modal open={open}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "white",
        padding: "30px",
        borderRadius: "10px",
        textAlign: "center",
      }}
    >
      <CircularProgress size={50} />
      <Typography variant="h6" sx={{ marginTop: 2 }}>
        Uploading data to cloud storage...
      </Typography>
    </Box>
  </Modal>
);

export default ImageGalleryV2;
